// extracted by mini-css-extract-plugin
export var addressFields = "_jc-0";
export var animationContainer = "_jc-1";
export var footer = "_jc-2";
export var lineItems = "_jc-3";
export var modalContent = "_jc-4";
export var orderName = "_jc-5";
export var strong = "_jc-6";
export var warning = "_jc-7";